import Logger from './Logger';
import VerboseLogLevelUtils, { VerboseLogLevels } from './VerboseLogLevelUtils';
import StringFormatter from "./StringFormatter";
import UserNotificationUtils from "./UserNotificationUtils";
const TAG = 'ErrorHandlingUtils';
export default class ErrorHandlingUtils {
    static maybeHandleCommonHttpError(error) {
        if ([
            ErrorHandlingUtils.ERROR_CODE_CSRF_AUTHENTICATION_FAILED,
            ErrorHandlingUtils.ERROR_CODE_INVALID_API_VERSION_ERROR,
        ].includes(error.id)) {
            UserNotificationUtils.showError(ErrorHandlingUtils.REFRESH_ERROR_MESSAGE);
            return true;
        }
        return false;
    }
    static maybeHandleNightlyIssueError(error) {
        if ([
            ErrorHandlingUtils.ERROR_CODE_BAD_GATEWAY,
            ErrorHandlingUtils.ERROR_CODE_TIME_OUT,
        ].includes(error.id)) {
            UserNotificationUtils.showError(ErrorHandlingUtils.NIGHTLY_ISSUE_ERROR_MESSAGE);
            return true;
        }
        return false;
    }
    static handleError(error) {
        const outputText = StringFormatter(error.id, error.parameters);
        UserNotificationUtils.showError(outputText);
    }
    /**
     * This method handles a critical error, i.e. an error which can't be recovered from.
     *
     * @param errorCode Error code (assuming 500 by default)
     */
    static handleCriticalError(errorCode = 500) {
        let targetLocation;
        if (errorCode < 500) {
            targetLocation = '/login/logout';
        }
        else {
            targetLocation = '/p/maintenance';
        }
        const forceRedirect = VerboseLogLevelUtils.getLevel() === VerboseLogLevels.NONE;
        if (forceRedirect) {
            window.location.href = targetLocation;
        }
        else {
            Logger.error(TAG, '***********************************');
            Logger.error(TAG, ' NOT REDIRECTING ON CRITICAL ERROR');
            Logger.error(TAG, `   Location: ${targetLocation}`);
            Logger.error(TAG, '***********************************');
        }
    }
}
ErrorHandlingUtils.GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';
ErrorHandlingUtils.REFRESH_ERROR_MESSAGE = 'Please refresh before trying again.';
// HACKY
ErrorHandlingUtils.NIGHTLY_ISSUE_ERROR_MESSAGE = 'Unable to save changes at the moment. Please try again in a few minutes.';
ErrorHandlingUtils.ERROR_CODE_CSRF_AUTHENTICATION_FAILED = "csrf_authentication_failed";
ErrorHandlingUtils.ERROR_CODE_INVALID_API_VERSION_ERROR = "invalid_api_version_error";
ErrorHandlingUtils.ERROR_CODE_LARGE_REQUEST_ENTITY = "request_entity_too_large";
ErrorHandlingUtils.ERROR_CODE_INVALID_PARAMETER = "invalid_parameter";
ErrorHandlingUtils.ERROR_CODE_ACCESS_DENIED = "access_denied";
ErrorHandlingUtils.ERROR_CODE_BAD_GATEWAY = "bad_gateway";
ErrorHandlingUtils.ERROR_CODE_TIME_OUT = "time_out";
ErrorHandlingUtils.ERROR_CODE_BAD_HTTP = "bad_http_code";
ErrorHandlingUtils.ERROR_CODE_REQUEST_CANCELLED = "request_cancelled";
// This key may be present for errors with code invalid_parameter
ErrorHandlingUtils.INVALID_PARAMETER_SUB_ID = 'sub_id';
//# sourceMappingURL=ErrorHandlingUtils.js.map